import dynamic from 'next/dynamic'

const DynamicConfigSearchButton = dynamic(
    () => import('@components/configsearch/nav/ConfigSearchButton'),
    { ssr: false },
)

const ConfigSearchButton = (props) => <DynamicConfigSearchButton {...props} />

export default ConfigSearchButton